import { Env } from './env';
import { envbase } from './envbase';

export const environment: Env = {
  ...envbase,
  env: 'azure',
  production: true,
  apiUrl: 'https://proximity-api.ideablade.com/api/',
  adaptUrl: 'https://proximity-api.ideablade.com/api/Adapt',
  adminUrl: 'https://proximity-api.ideablade.com/api/Admin',
  accountUrl: 'https://proximity-api.ideablade.com/api/Account',
  supplierUrl: 'https://proximity-api.ideablade.com/api/Supplier',
  globalUrl: 'https://proximity-api.ideablade.com/api/Global',
  transactionUrl: 'https://proximity-api.ideablade.com/api/Transaction',
  ruleUrl: 'https://proximity-api.ideablade.com/api/Rule',
  sentryDsn: 'https://c0bb27336dfc117efc5991ab6b83d80e@o1261118.ingest.us.sentry.io/4509312641597440',
};
